import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FirstTimeAccountSetupComponent} from 'src/app/components/first-time-account-setup/first-time-account-setup.component';
import {ResetPasswordComponent} from 'src/app/components/reset-password/reset-password.component';
import {TermsAndConditionsComponent} from 'src/app/components/terms-and-conditions/terms-and-conditions.component';
import {UpdatePasswordComponent} from 'src/app/components/update-password/update-password.component';
import {LoginExtraModule} from '../modules/login-extra.module';
import {BRANDS} from '../../../luxengine-brand-kit/brands';
import {LUXENGINE_LOGO_ON_LIGHT} from '../../services/brand.service';

const loginExtraRoutes: Routes = [
    {
        path: '',
        component: FirstTimeAccountSetupComponent
    },
    {
        path: 'termsandconditions',
        component: TermsAndConditionsComponent
    },
    {
        path: 'passwordreset',
        component: ResetPasswordComponent,
        data: {brand: 'luxengine', logo: LUXENGINE_LOGO_ON_LIGHT, alt: BRANDS.luxengine.displayName, loginRoute: '/login'}
    },
    {
        path: 'passwordreset/bwrm',
        component: ResetPasswordComponent,
        data: {brand: 'bwrm', logo: 'assets/images/bwrm-new-logo.png', alt: 'BWRM', loginRoute: '/login/bwrm'}
    },
    {
        path: 'update-password',
        component: UpdatePasswordComponent
    }
];

export const LoginExtraRouting: ModuleWithProviders<LoginExtraModule> = RouterModule.forChild(loginExtraRoutes);
